import { render, staticRenderFns } from "./ContactFollowupRuleDialog.vue?vue&type=template&id=116a9404&scoped=true&"
import script from "./ContactFollowupRuleDialog.vue?vue&type=script&lang=js&"
export * from "./ContactFollowupRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a9404",
  null
  
)

export default component.exports